import GlassWallSelectionPage from '../components/GlassWallSelectionPage'
import { connect } from 'react-redux'
import { getGlassMaterials, getGlassListMaterials } from '../reducers/materialStore';
import { changeDoorType, changeDoorMaterial, changeGlassListMaterial, changeDoorHandness, restoreDefaultGlassWall, markGlassWallEdited } from '../actions/door';
import { contentRoot } from '../config.js';
import Localization from '../helpers/localization';
import { getWebpAwareExtension } from '../helpers/webpSupport';
let imageExtentsion = getWebpAwareExtension();


const mapDispatchToProps = (dispatch, ownProps) => ({
    doorMaterialChanged: (e) => {
        dispatch(changeDoorMaterial(e.id));
    },
    doorTypeChanged: (e) => {
        dispatch(changeDoorType(e.id));
    },
    glassListMaterialChanged:(e) => {
        dispatch(changeGlassListMaterial(e.id));      
    },
    restoreDefaultGlassWall: () => {
        dispatch(markGlassWallEdited());
        dispatch(restoreDefaultGlassWall());
    },
    doorHandnessChanged: () => {
        dispatch(changeDoorHandness());
    }
});


const mapStateToProps = (state, ownProps) => ({
    glassMaterials: getGlassMaterials(state),
    glassListMaterials: getGlassListMaterials(state),
    prices: state.optionPricing.glassPrices,
    showPrices: state.clientConfiguration.showPrices,
    selectedMaterial: state.measurements.glassMaterial,
    selectedGlassListMaterial: state.measurements.glassListMaterial,
    showMaterial: state.measurements.doorType != 'ownDoor',
    showListMaterial: state.measurements.doorType =="customGlassWall",
    doorImage: doorImages[state.measurements.doorType],
    doorType: state.measurements.doorType,
    doorOptions: getDoorOptions(),
    measurementsSkipped: state.measurements.skipped,
    glassPrice: state.optionPricing.glassPrice,
    
});
const GlassWallSelectionPageContainer = connect(mapStateToProps, mapDispatchToProps)(GlassWallSelectionPage)

export default GlassWallSelectionPageContainer


let doorImages = {
    customGlassWall: contentRoot + "/img/doorWall/customGlassWall" + imageExtentsion,
    doorWithCarms: contentRoot + "/img/doorWall/doorWithCarms" + imageExtentsion,
    ownDoor: contentRoot + "/img/doorWall/ownDoor" + imageExtentsion,

}
let getDoorOptions = () => [
    { id: "customGlassWall", name: Localization.customGlassWall, thumbnail: "img/doorWall/glassWallIcon" +  imageExtentsion },  
    { id: "doorWithCarms", name: Localization.doorWithCarms, thumbnail: "img/doorWall/doorWithCarmsIcon" + imageExtentsion },
    { id: "ownDoor", name: Localization.ownDoor, thumbnail: "./img/doorWall/ownDoorIcon" +  imageExtentsion }
]
